import type { BareMetalSpec } from './schema';

export const bareMetalMigrations: Record<number, (data: unknown) => BareMetalSpec> = {
  1: (data) => {
    const old = data as Record<string, unknown>;
    return {
      name: String(old.name ?? ''),
      description: String(old.description ?? ''),
      workspace: old.workspace ? String(old.workspace) : undefined,
      datacenter: old.datacenter ? String(old.datacenter) : undefined,
      optionMeta: old.optionMeta ? (old.optionMeta as Record<string, unknown>) : undefined,
      bmsNode: old.bmsNode ? String(old.bmsNode) : undefined,
      powerPolicy: old.powerPolicy ? String(old.powerPolicy) : undefined,
      network: old.network
        ? {
            vpc: (old.network as Record<string, unknown>).vpc ? { name: String((old.network as Record<string, unknown>).vpc) } : undefined,
            subnet: (old.network as Record<string, unknown>).subnet
              ? { name: String((old.network as Record<string, unknown>).subnet) }
              : undefined,
            securitygroup: (old.network as Record<string, unknown>).securitygroup
              ? { name: String((old.network as Record<string, unknown>).securitygroup) }
              : undefined,
            staticIpv4: (old.network as Record<string, unknown>).staticIpv4
              ? String((old.network as Record<string, unknown>).staticIpv4)
              : undefined,
            services: (old.network as Record<string, unknown>).services
              ? ((old.network as Record<string, unknown>).services as unknown[])
              : undefined,
          }
        : undefined,
      systemVolume: old.systemVolume
        ? {
            image: (old.systemVolume as Record<string, unknown>).image
              ? String((old.systemVolume as Record<string, unknown>).image)
              : undefined,
            os: (old.systemVolume as Record<string, unknown>).os ? String((old.systemVolume as Record<string, unknown>).os) : undefined,
            version: (old.systemVolume as Record<string, unknown>).version
              ? String((old.systemVolume as Record<string, unknown>).version)
              : undefined,
            architecture: (old.systemVolume as Record<string, unknown>).architecture
              ? String((old.systemVolume as Record<string, unknown>).architecture)
              : undefined,
            kernel: (old.systemVolume as Record<string, unknown>).kernel
              ? String((old.systemVolume as Record<string, unknown>).kernel)
              : undefined,
            initrd: (old.systemVolume as Record<string, unknown>).initrd
              ? String((old.systemVolume as Record<string, unknown>).initrd)
              : undefined,
            root: (old.systemVolume as Record<string, unknown>).root
              ? String((old.systemVolume as Record<string, unknown>).root)
              : undefined,
          }
        : undefined,
    };
  },
};
